/**
 * Created by zack on 2016/7/25.
 */
import Vue from 'vue'
import VueResource from 'vue-resource'
import Store from '../store'
import md5 from 'md5'
import FP from 'fingerprintjs2/fingerprint2'
import * as types from '../store/modules/common/mutation-types'
import { throttle } from '../utils/commons'

Vue.use(VueResource)

// Vue.http.options.crossOrigin = true
// Vue.http.options.xhr = {withCredentials: true}

const debug = process.env.NODE_ENV !== 'production'
const YC_WEB_COURSES = debug ? 'http://test.server.51zy.org:8080/app/' : 'http://dsww.51zy.org/'
const API_ROOT = debug ? 'https://wu.51zy.org/m/' : 'https://wu.51zy.org/m/'
const EXPERT_API_ROOT = debug ? 'https://daoshi.51zy.org/rest/' : 'https://daoshi.51zy.org/rest/'
const WEIXIN_API_ROOT = debug ? 'http://wcservice.51zy.org/rest/' : 'http://wcservice.51zy.org/rest/'
const WEIXIN_AUTH_ROOT = debug ? 'https://xgkzy.51zy.org/rest/' : 'https://xgkzy.51zy.org/rest/'
const MS_JSON_ROOT = debug ? 'http://51zyresource.oss-cn-qingdao.aliyuncs.com/microsite/testing/' : 'http://51zyresource.oss-cn-qingdao.aliyuncs.com/microsite/production/'
// Vue.http.interceptors.push((request, next) => {
//   next()
// })
let getIp = () => {
  // return Vue.http.post('http://ip.taobao.com/service/getIpInfo2.php', {ip: 'myip'}, {emulateJSON: true})
  return Vue.http.get('http://ip.taobao.com/service/getIpInfo.php?ip=myip')
}
let environment = {
  yckey: '15IEEk0+WheZKqCqsbKGk3'
}
// 计算yc-sign
let xycsign
let getSign = function () {
  let timestamp = Date.now()
  // Access your env variables like this
  let str = timestamp + environment.yckey
  let sign = md5(str)
  // Set the new environment variable
  xycsign = sign + ',' + timestamp
}
const getFP = new Promise((resolve) => {
  new FP({excludeAudioFP: true}).get(result => {
    Vue.http.headers.common['yc-f'] = result
    resolve()
  })
})

const alertMessage = () => window.alert('请求过于频繁,请稍后再试')
const wuApiErrorHandler = async (res) => {
  const {code} = await res.json()
  if (code === 40002) {
    throttle(alertMessage, 500).call(this)
  }
  return res
}
let WeixinAuthPost = async (url, data, option) => {
  await getFP
  return Vue.http.post(WEIXIN_AUTH_ROOT + url, data, option)
}
let WeixinPost = async (url, data, option) => {
  await getFP
  return Vue.http.post(WEIXIN_API_ROOT + url, data, option)
}
let ExpertPost = async (url, data, option) => {
  await getFP
  console.info('oopopccount', Store)
  const account = Store.state.common.account
  let userId = account.user_id
  let token = account.token
  const r = await Vue.http.post(EXPERT_API_ROOT + url, {data: data, user_id: userId, token: token}, option)
  const {code} = await r.json()
  switch (code) {
    case 200:
      return r
    case 498:
      Store.dispatch(types.LOGIN_FAILED)
      break
  }
}
let post = async (url, data, option) => {
  await getFP
  // const account = Store.state.account
  // data.user_id = account.user_id
  // data.token = account.token
  return Vue.http.post(API_ROOT + url, data, option).then(wuApiErrorHandler)
}
let WeixinGet = async (url, option) => {
  await getFP
  return Vue.http.get(WEIXIN_API_ROOT + url, option)
}
let ExpertGet = async (url, option) => {
  await getFP
  const r = await Vue.http.get(EXPERT_API_ROOT + url, option)
  const {code} = await r.json()
  switch (code) {
    case 200:
      return r
    case 498:
      Store.dispatch(types.LOGIN_FAILED)
      break
  }
}
let get = async (url, option) => {
  await getFP
  return Vue.http.get(API_ROOT + url, option).then(wuApiErrorHandler)
}
let getHtml = async (url, option) => {
  await getFP
  return Vue.http.get(url, option)
}
let getMSJson = async (url, option) => {
  await getFP
  return Vue.http.get(MS_JSON_ROOT + url, option)
}
let postHml = async (url, data, option) => {
  await getFP
  return Vue.http.post(url, data, option)
}
let postCourse = (url, data) => {
  getSign()
  return Vue.http.post(YC_WEB_COURSES + url, data, {headers: {'X-YC-SIGN': xycsign}})
}
let getMiniProgram = async (url, options) => {
  await getFP
  return Vue.http.get('https://chat.51zy.org:8888/' + url, options)
}

export default {
  WeixinAuthPost,
  WeixinPost,
  ExpertPost,
  post,
  WeixinGet,
  ExpertGet,
  get,
  getHtml,
  getMSJson,
  postHml,
  postCourse,
  getIp,
  getMiniProgram
}



// WEBPACK FOOTER //
// ./src/api/config.js